import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from './Services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let clonedRequest = req;
    const startTime = Date.now();
    const url = req.url;
    const isFormData = req.body instanceof FormData;

    if (!isFormData && !req.headers.has('Content-Type')) {
      clonedRequest = req.clone({

        withCredentials: true,
        setHeaders: { 'Content-Type': 'application/json' }
      });
    } else {
      clonedRequest = req.clone({ withCredentials: true });
    }

    //return next.handle(clonedRequest).pipe(
    //  catchError((error: HttpErrorResponse) => {
    //    if (error.status === 401) {
    //      console.warn('Unauthorized request - Redirecting to login');
    //      this.authService.logOut();
    //      return throwError(() => new Error('Unauthorized - Logging out'));
    //    }
    //    return throwError(() => error);
    //  })
    //);
    return next.handle(clonedRequest).pipe(

      // :white_check_mark: SUCCESS / PERFORMANCE LOGGING
      tap(() => {
        const duration = Date.now() - startTime;

        // log ONLY slow APIs
        if (duration > 90000) {
          console.warn(`SLOW API :warning: ${url} took ${duration}ms`);
        }
      }),

      // :x: ERROR HANDLING
      catchError((error: HttpErrorResponse) => {

        const duration = Date.now() - startTime;

        console.error(`FAILED API :x: ${url} took ${duration}ms`, error);

        if (error.status === 401) {
          console.warn('Unauthorized request - Redirecting to login');
          this.authService.logOut();
          return throwError(() => new Error('Unauthorized - Logging out'));
        }

        return throwError(() => error);
      })
    );
  }
}
